/* eslint-disable react-hooks/exhaustive-deps */
import {useEffect, useRef} from 'react';

export function useMountEffect(func: () => void) {
  const mounted = useRef(false);

  useEffect(() => {
    if (!mounted.current) {
      mounted.current = true;
      func();
    }
  }, []);
}
